/**
 * Keeps a draft intact when Android sends text into the running app.
 * This function intentionally has no Tauri or storage dependency: shared
 * plaintext stays in memory and the caller decides how to render it.
 */
export function mergeSharedTextIntoComposer(currentContent: string, sharedText: string): string {
  if (!currentContent) return sharedText;
  return `${currentContent}${currentContent.endsWith("\n") ? "" : "\n"}${sharedText}`;
}

export function sharedFilePayloadToFile(payload: { name?: unknown; mime?: unknown; base64?: unknown }): File | null {
  if (typeof payload.name !== "string" || !payload.name || typeof payload.base64 !== "string" || !payload.base64) return null;
  try {
    const decoded = atob(payload.base64);
    const bytes = Uint8Array.from(decoded, character => character.charCodeAt(0));
    return new File([bytes], payload.name, { type: typeof payload.mime === "string" && payload.mime ? payload.mime : "application/octet-stream" });
  } catch { return null; }
}
